"use client";

import { Aperture, Armchair, Disc, Film, Wine } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Gamerddosprotection() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const features = [{
    number: "01",
    title: "REAL-TIME MITIGATION",
    description: "Advanced traffic scrubbing engines detect and neutralize volumetric DDoS attacks instantly, ensuring your gaming sessions remain uninterrupted.",
    icon: Aperture,
    rotation: "-rotate-[1.5deg]",
    offset: "lg:mt-0 lg:ml-8"
  }, {
    number: "02",
    title: "GLOBAL SERVER NODES",
    description: "A vast network of high-speed servers optimized for low latency, providing stable connections across all major gaming regions worldwide.",
    icon: Wine,
    rotation: "rotate-[1deg]",
    offset: "lg:mt-16 lg:ml-0"
  }, {
    number: "03",
    title: "ENCRYPTED TUNNELS",
    description: "Military-grade encryption protocols protect your data packets, preventing ISP throttling and keeping your personal IP address hidden.",
    icon: Armchair,
    rotation: "-rotate-[1deg]",
    offset: "lg:mt-8 lg:ml-16"
  }, {
    number: "04",
    title: "ZERO-LOG POLICY",
    description: "We maintain a strict no-logs policy, ensuring your gaming history and online activities remain completely private and untraceable.",
    icon: Film,
    rotation: "rotate-[1.5deg]",
    offset: "lg:mt-0 lg:ml-4"
  }, {
    number: "05",
    title: "24/7 TECH SUPPORT",
    description: "Dedicated security experts available around the clock to assist with configuration, troubleshooting, and network optimization needs.",
    icon: Disc,
    rotation: "-rotate-[1deg]",
    offset: "lg:mt-12 lg:ml-20"
  }];
  return <section data-section-id="2818" id="gamerddosprotection" className="bg-background text-foreground">
      <div className="py-24 md:py-40 lg:py-[200px] px-6 md:px-12 lg:px-16">
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={headerRef} className={`lg:col-span-5 transition-all duration-1000 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="font-mono text-xs md:text-sm tracking-widest mb-8 md:mb-12 text-primary">
              03 — PROTECTION
            </div>

            <h2 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl xl:text-[80px] leading-[0.95] tracking-tight mb-10 md:mb-14 text-foreground">
              Unrivaled
              <br />
              Security.
            </h2>

            <p className="font-sans text-base md:text-lg leading-[1.7] mb-10 md:mb-12 max-w-md text-muted-foreground">
              VPNGENIX is not just a VPN. It is a robust shield engineered for gamers, streamers, and professionals who demand absolute network integrity. Your connection stays secure, fast, and private.
            </p>

            <div className="h-px w-32 bg-primary" />
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              const {
                ref,
                isVisible
              } = useRevealOnScroll<HTMLDivElement>({
                threshold: 0.15
              });
              return <div key={i} data-index={i} ref={ref} className={`${feature.offset} ${feature.rotation} transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
                transitionDelay: `${i * 100}ms`
              }}>
                    <div className="relative p-8 md:p-10 backdrop-blur-md bg-card shadow-lg border border-border">
                      <div className="flex items-start justify-between mb-10 md:mb-14">
                        <span className="font-mono text-xs tracking-widest text-primary">
                          {feature.number}
                        </span>
                        <Icon className="w-5 h-5 md:w-6 md:h-6 text-foreground" strokeWidth={1} />
                      </div>

                      <h3 className="font-default font-bold text-lg md:text-xl tracking-tight leading-tight mb-5 md:mb-6 text-foreground">
                        {feature.title}
                      </h3>

                      <p className="font-sans text-sm md:text-[15px] leading-[1.65] text-muted-foreground">
                        {feature.description}
                      </p>

                      <div className="absolute bottom-0 left-0 h-px w-12 bg-primary" />
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}